<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  page: {
    title: "Expense Report",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: { Layout, PageHeader, ModelListSelect, Loader },

  data() {
    return {
      title: "Expense Report",
      items: [
        { text: "Home", href: "#/" },
        { text: "Expense Report", active: true },
      ],

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],

      currentdate: moment().format("YYYY-MM-DD"),
      viewMode: "expense",

      fields: [
        { key: "index", label: "S/N" },
        { key: "date", label: "DATE" },
        { key: "supplier", label: "Supplier" },
        { key: "amount_field", label: "AMOUNT" },
        { key: "paid_field", label: "PAID" },
        { key: "balance_field", label: "BALANCE" },
        { key: "details", label: "DETAILS" },
        { key: "user", label: "MADE BY" },
      ],

      fields1: [
        { key: "index", label: "S/N" },
        { key: "date", label: "DATE" },
        { key: "supplier", label: "Supplier" },
        { key: "amount_field", label: "AMOUNT" },
        { key: "paid_field", label: "PAID" },
        { key: "balance_field", label: "BALANCE" },
        { key: "details", label: "DETAILS" },
        { key: "user", label: "MADE BY" },
        { key: "branch.name", label: "BRANCH" },
      ],

      itemFields: [
        { key: "index", label: "S/N" },
        { key: "date", label: "DATE" },
        { key: "supplier", label: "SUPPLIER" },
        { key: "name", label: "ITEM" },
        { key: "quantity", label: "QTY" },
        { key: "amount", label: "UNIT PRICE" },
        { key: "total", label: "TOTAL" },
        { key: "description", label: "DESCRIPTION" },
        { key: "user", label: "MADE BY" },
      ],

      data: {
        dateto: moment().format("YYYY-MM-DD"),
        datefrom: moment().format("YYYY-MM-DD"),
        category: "",
        type: "",
        branch_id: 0,
      },
    };
  },

  computed: {
    ...mapGetters("expenses", ["Expenses", "ExpenseCategories", "filterStatus"]),
    ...mapGetters("auth", ["branchid", "Branches"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    tableData() {
      return this.Expenses || [];
    },

    rows() {
      return this.tableData.length;
    },

    // ✅ GRAND TOTALS (ALL DATA)
    totalAmount() {
      if (this.viewMode === "expense") {
        return this.tableData.reduce((s, e) => s + Number(e.amount || 0), 0);
      }
      return this.tableData.reduce((s, i) => s + Number(i.total || 0), 0);
    },

    totalQuantity() {
      if (this.viewMode === "expense") return 0;
      return this.tableData.reduce((s, i) => s + Number(i.quantity || 0), 0);
    },

    savedAmount() {
      if (this.viewMode === "expense") {
        return this.tableData.reduce((s, e) => s + Number(e.saved_amount || 0), 0);
      }
      return this.tableData.reduce((s, i) => s + Number(i.saved_amount || 0), 0);
    },
  },

  methods: {
    ...mapActions({
      FetchExpenses: "expenses/fetchExpensesReport",
      FetchExpenseCategories: "expenses/fetchExpenseCategories",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),

    thousandSeperator(m) {
      if (m !== null && m !== undefined) {
        return m.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return m;
    },

    filterReport() {
      this.FetchExpenses(this.data).then(() => {
        this.viewMode = this.data.category ? "item" : "expense";
        this.currentPage = 1;
      });
    },
  },

  created() {
    this.FetchExpenses(this.data);
    this.FetchExpenseCategories();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">

        <!-- FILTERS -->
        <div class="row">
          <div class="col-md-8"></div>

          <div v-if="branchid == 0" class="col-md-4 mb-2">
            <label>FILTER BY BRANCHES</label>
            <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []"
              v-model="data.branch_id" option-value="id" option-text="name" @input="filterReport()" />
          </div>
        </div>

        <!-- ✅ EXPORT BACK -->
        <div class="row">
          <div class="col-md-10"></div>
          <div class="col-md-2">
            <download-excel class="btn btn-primary mt-4" :data="tableData"
              :worksheet="'EXPENSES REPORT ' + currentdate">
              <i class="fa fa-file-excel"></i> Export Excel
            </download-excel>
          </div>
        </div>

        <!-- FILTER OPTIONS -->
        <div class="row mt-3">
          <div class="col-md-3">
            <label>FILTER BY EXPENSE TYPES</label>
            <select v-model="data.type" class="form-control" @change="filterReport()">
              <option value="">Select Type</option>
              <option value="1">General Production Expenses</option>
              <option value="3">Production Batch Expenses</option>
              <option value="2">Operating Expenses</option>
            </select>
          </div>

          <div class="col-md-3">
            <label>FILTER BY ITEM CATEGORY</label>
            <model-list-select :list="ExpenseCategories || []" v-model="data.category" option-value="id"
              option-text="name" @input="filterReport()" />
          </div>

          <div class="col-md-2">
            <label>FROM</label>
            <input type="date" v-model="data.datefrom" class="form-control" />
          </div>

          <div class="col-md-2">
            <label>TO</label>
            <input type="date" v-model="data.dateto" class="form-control" />
          </div>

          <div class="col-md-2 mt-4">
            <button class="btn btn-primary" @click="filterReport()">
              Filter
              <b-spinner v-show="filterStatus" small></b-spinner>
            </button>
          </div>
        </div>

        <!-- TABLE -->
        <div class="table-responsive mt-3">
          <b-table :items="tableData" :fields="viewMode === 'expense' ? (branchid == 0 ? fields1 : fields) : itemFields"
            :per-page="perPage" :current-page="currentPage">
            <template #cell(index)="data">
              {{ (currentPage - 1) * perPage + data.index + 1 }}
            </template>

            <template #cell(amount_field)="data">
              {{ thousandSeperator(data.item.amount) }}
            </template>

            <template #cell(paid_field)="data">
              {{ thousandSeperator(data.item.paid) }}
            </template>

            <template #cell(balance_field)="data">
              {{ thousandSeperator(data.item.balance) }}
            </template>

            <template #cell(details)="data">
              <table class="table table-sm">
                <tr v-for="(d, i) in data.item.items" :key="i">
                  <td>{{ d.name }}</td>
                  <td>{{ d.quantity }}</td>
                  <td>{{ d.amount }}</td>
                  <td>{{ d.total }}</td>
                </tr>
              </table>
            </template>
          </b-table>
        </div>

        <!-- TOTALS -->
        <div class="text-center mt-3">
          <div class="row justify-content-center">

            <div class="col-12 col-md text-center">
              <h5>Total: {{ thousandSeperator(totalAmount) }}</h5>
            </div>

            <div class="col-12 col-md text-center" v-if="GeneralSettings.save_expenses == 1">
              <h5>Total Savings: {{ thousandSeperator(savedAmount) }}</h5>
            </div>

            <div class="col-12 col-md text-center" v-if="GeneralSettings.save_expenses == 1">
              <h5>Total Payable: {{ thousandSeperator(totalAmount - savedAmount) }}</h5>
            </div>

            <div class="col-12 col-md text-center" v-if="viewMode !== 'expense'">
              <h5>Total Quantity: {{ thousandSeperator(totalQuantity) }}</h5>
            </div>

          </div>
        </div>

        <!-- LOADER -->
        <Loader v-if="filterStatus" />

        <!-- PAGINATION -->
        <div class="mt-3 text-end">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" />
        </div>

      </div>
    </div>
  </Layout>
</template>